import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  /** Optional label rendered next to the spinner. */
  label?: string;
  /** Size in px. Default 20. */
  size?: number;
  className?: string;
}

/**
 * Minimal editorial spinner. Ochre tint, mono caption.
 */
export function LoadingSpinner({ label, size = 20, className }: LoadingSpinnerProps) {
  return (
    <div className={cn('inline-flex items-center gap-3 text-graphite', className)}>
      <Loader2
        className="animate-spin text-ochre"
        style={{ width: size, height: size }}
        aria-hidden
      />
      {label ? <span className="font-mono text-xs">{label}</span> : null}
    </div>
  );
}
